import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import DerivEHero from "./DerivEHero";
import WhatisCDE from "./WhatisCDE";
import Futures from "./Futures";
import PerpetualSwaps from "./PerpetualSwaps";
import PerformanceMatching from "./PerformanceMatching";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function DerivativesExchange() {
  return (
    <div>
      <Header />
      <DerivEHero />
      <WhatisCDE />
      <Futures />
      <PerpetualSwaps />
      <PerformanceMatching />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default DerivativesExchange;
